import Api from "api/Api";
import type { AxiosProgressEvent, AxiosPromise } from "axios";
import type { ApiResponse } from "api/ApiResponses";
import type { AppSnapshotList } from "constants/AppConstants";
import type { PaginationParam } from "constants/ApiEditorConstants/ApiEditorConstants";
import type { JSONValue } from "utils/AppUtils";

export interface AppSnapshotsResp extends ApiResponse {
  data: AppSnapshotList;
}

export interface AppSnapshotDslInfo {
  applicationsDsl: JSONValue;
  moduleDSL: Record<string, JSONValue>;
}

export interface AppSnapshotDslResp extends ApiResponse {
  data: AppSnapshotDslInfo;
}

class HomeApi extends Api {
  static recentlyCaseURL = `/v1/dashboard/recentResources`;
  static quickAccessURL = "/v1/dashboard/quickAccess";
  static pinApplicationURL = "/v1/applications/";
  static getRecentlyCase(request: any): AxiosPromise<ApiResponse> {
    return Api.get(HomeApi.recentlyCaseURL, request);
  }

  static getQuickAccess(request: any): AxiosPromise<ApiResponse> {
    return Api.get(HomeApi.quickAccessURL, request);
  }

  static pinApplication(request: any): AxiosPromise<ApiResponse> {
    return Api.put(
      HomeApi.pinApplicationURL +
        "/" +
        request.applicationId +
        `/setting?pinTop=${request.pinTop}`,
      {},
    );
  }
}

export default HomeApi;
